





































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() customerId!: number;

  handleSubmit() {
    if (!this.checkPermission('admin-stadium-manager-mobile')) {
      this.$message.error('没有权限');
      return;
    }
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            const res = await this.$store.dispatch('customer/editadmin', {
              customer_id: this.customerId,
              stadium_id: this.stadiumId,
              username: '',
              old_mobile: this.formData.mobile,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.loadData1();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  removeAdmin() {
    if (!this.checkPermission('admin-stadium-manager-mobile')) {
      this.$message.error('没有权限');
      return;
    }

    this.showTsConfirm({
      title: '确认信息',
      content: '确定要移除登录手机号吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('customer/removeadmin', {
          customer_id: this.customerId,
          stadium_id: this.stadiumId,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  async loadData1() {
    const res = await this.$store.dispatch('customer/detail', {
      id: this.customerId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.formData = res.Data;
    }
  }

  mounted() {
    console.log(this.stadiumId);
    console.log(this.customerId);
    console.log('mounted12');
    console.log(this.stadiumId);
    console.log(this.customerId);
    this.loadData1();
  }
}
